export const SET_PASS_REST = "[APP] SUCCESSFUL PASSWORD RESET";
export const LOGOUT_USER = "[APP] NAVIGATE TO LOGOUT";
export const SHOW_GOBACK = "[APP] SHOW GO BACK BUTTON";
export const SET_CONFIRMATION_MODAL = "[APP] SET CONFIRMATION MODAL";
export const HIDE_CONFIRMATION_MODAL = "[APP] HIDE CONFIRMATION MODAL";
export const SET_SELECTED_BU = "[APP] SET SELECTED BU";
export const SET_SLECTING_BU = "[APP] SET SELECTING BU";
